var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function normalize(strArray) {
  var resultArray = [];
  if (strArray.length === 0) {
    return "";
  }
  if (typeof strArray[0] !== "string") {
    throw new TypeError("Url must be a string. Received " + strArray[0]);
  }
  if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
    var first = strArray.shift();
    strArray[0] = first + strArray[0];
  }
  if (strArray[0].match(/^file:\/\/\//)) {
    strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
  } else {
    strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
  }
  for (var i = 0; i < strArray.length; i++) {
    var component = strArray[i];
    if (typeof component !== "string") {
      throw new TypeError("Url must be a string. Received " + component);
    }
    if (component === "") {
      continue;
    }
    if (i > 0) {
      component = component.replace(/^[\/]+/, "");
    }
    if (i < strArray.length - 1) {
      component = component.replace(/[\/]+$/, "");
    } else {
      component = component.replace(/[\/]+$/, "/");
    }
    resultArray.push(component);
  }
  var str = resultArray.join("/");
  str = str.replace(/\/(\?|&|#[^!])/g, "$1");
  var parts = str.split("?");
  str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
  return str;
}
function urlJoin() {
  var input;
  if (typeof arguments[0] === "object") {
    input = arguments[0];
  } else {
    input = [].slice.call(arguments);
  }
  return normalize(input);
}
function hasKey(data, key) {
  return !!data && Object.prototype.hasOwnProperty.call(data, key);
}
function hasKeys(data, ...keys) {
  const clonedKeys = [...keys];
  const key = clonedKeys.shift();
  if (!key) {
    return true;
  }
  return !!data && hasKey(data, key) && hasKeys(data[key], ...clonedKeys);
}
function nullString(value, fallback = null) {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number") {
    return value.toString(10);
  }
  return fallback;
}
function nullBoolean(value, fallback = null) {
  return typeof value === "boolean" ? value : fallback;
}
function transformDynamic(data) {
  if (!data || typeof data !== "object") {
    return { shop: null, rudderstack: null };
  }
  return {
    shop: hasKey(data, "shop") ? transformDynamicShop(data.shop) : null,
    rudderstack: hasKey(data, "rudderstack") ? transformDynamicRudderstack(data.rudderstack) : null
  };
}
function transformDynamicShop(data) {
  if (!data || typeof data !== "object") {
    return null;
  }
  return {
    pages: hasKey(data, "pages") ? transformDynamicShopPages(data.pages) : [],
    listeners: hasKey(data, "listeners") ? transformDynamicShopListeners(data.listeners) : []
  };
}
function transformDynamicShopPages(data) {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map((value) => transformDynamicShopPage(value)).filter((value) => !!value);
}
function transformDynamicShopPage(data) {
  if (!data || typeof data !== "object") {
    return null;
  }
  if (!hasKey(data, "modules") || !hasKey(data, "name") || !hasKey(data, "title")) {
    return null;
  }
  if (typeof data.name !== "string" || typeof data.title !== "string") {
    return null;
  }
  const page = {
    modules: transformDynamicShopPageModules(data.modules),
    name: data.name,
    title: data.title
  };
  if (!page.modules.length || !page.name || !page.title) {
    return null;
  }
  if (hasKey(data, "hideOrderBar") && typeof data.hideOrderBar === "boolean") {
    page.hideOrderBar = data.hideOrderBar;
  }
  return page;
}
function transformDynamicShopPageModules(data) {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map((value) => transformDynamicShopPageModule(value)).filter((value) => !!value);
}
function transformDynamicShopPageModule(data) {
  if (!data) {
    return null;
  }
  if (typeof data === "string") {
    return data;
  }
  if (typeof data !== "object" || !hasKey(data, "name") || !data.name || typeof data.name !== "string") {
    return null;
  }
  return {
    ...data,
    name: data.name
  };
}
function transformDynamicRudderstack(data) {
  if (!data || typeof data !== "object") {
    return null;
  }
  return {
    dataplaneurl: hasKey(data, "dataplaneurl") && typeof data.dataplaneurl === "string" ? data.dataplaneurl : null,
    writekey: hasKey(data, "writekey") && typeof data.writekey === "string" ? data.writekey : null
  };
}
function transformDynamicShopListeners(data) {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map((value) => transformDynamicShopListener(value)).filter((value) => !!value);
}
function transformDynamicShopListener(data) {
  if (!data || typeof data !== "object") {
    return null;
  }
  if (typeof data !== "object" || !hasKey(data, "name") || !data.name || typeof data.name !== "string") {
    return null;
  }
  return {
    ...data,
    name: data.name
  };
}
const defaults = {
  order: {
    components: {
      eventCard: {
        closeUrl: null,
        disableDownloadButton: false,
        showEventDate: true,
        showLocation: true
      }
    },
    disableDownloadButton: false,
    enableAppic: false,
    enableCalendar: true,
    enableMave: false,
    enablePartyPay: false,
    enablePassbook: true,
    enablePromo: true,
    enableResell: true,
    enableTicketKeeper: false,
    enableTicketSwap: true,
    enableTixel: false,
    footer: {
      showCopyright: true,
      showLocaleSwitcher: true,
      showPoweredBy: true,
      showSupport: true
    },
    header: {
      showLogo: true
    }
  },
  shop: {
    blockFrameAccess: false,
    enableCoupons: true,
    enableTimeslotsFilters: true,
    footer: {
      showLocaleSwitcher: true,
      showPoweredBy: true
    },
    rememberTerms: false,
    seats: {
      hideLegend: false,
      hideSectionsNotForSale: false,
      tooltip: {
        hideActionHint: false,
        hideAvailability: false,
        hideCategory: false,
        hideLabel: false,
        hidePricing: false,
        hideUnavailableNotice: false
      }
    },
    showDateBlock: true,
    showReservationTimer: true
  },
  style: {
    button: {
      border: {
        radius: null
      }
    },
    card: {
      background: null,
      border: {
        radius: null
      },
      color: null,
      shadow: null
    },
    color: {
      core: {
        accent: {
          primary: null,
          secondary: null,
          tertiary: null
        },
        background: {
          primary: null,
          secondary: null
        },
        brand: null,
        "brand-invert": null,
        "brand-faded": null,
        foreground: {
          primary: null,
          secondary: null
        }
      }
    },
    heading: {
      font: {
        family: null,
        weight: null
      }
    },
    shop: {
      background: null,
      color: null,
      header: {
        color: {
          accent: null
        }
      }
    },
    text: {
      font: {
        family: null,
        weight: null
      }
    },
    transition: {
      default: {
        duration: null
      }
    }
  },
  theme: "light"
};
function transformStatic(data) {
  return {
    order: transformStaticOrder(hasKey(data, "order") ? data.order : null),
    shop: transformStaticShop(hasKey(data, "shop") ? data.shop : null),
    style: transformStaticStyle(hasKey(data, "style") ? data.style : null),
    theme: hasKey(data, "theme") && nullString(data.theme) || defaults.theme
  };
}
function transformStaticOrder(data) {
  return {
    components: {
      eventCard: transformStaticOrderComponentsEventCard(hasKeys(data, "components", "eventCard") ? data.components.eventCard : null)
    },
    disableDownloadButton: nullBoolean(hasKey(data, "disableDownloadButton") ? data.disableDownloadButton : null, defaults.order.disableDownloadButton),
    enableAppic: nullBoolean(hasKey(data, "enableAppic") ? data.enableAppic : null, defaults.order.enableAppic),
    enableCalendar: nullBoolean(hasKey(data, "enableCalendar") ? data.enableCalendar : null, defaults.order.enableCalendar),
    enableMave: nullBoolean(hasKey(data, "enableMave") ? data.enableMave : null, defaults.order.enableMave),
    enablePartyPay: nullBoolean(hasKey(data, "enablePartyPay") ? data.enablePartyPay : null, defaults.order.enablePartyPay),
    enablePassbook: nullBoolean(hasKey(data, "enablePassbook") ? data.enablePassbook : null, defaults.order.enablePassbook),
    enablePromo: nullBoolean(hasKey(data, "enablePromo") ? data.enablePromo : null, defaults.order.enablePromo),
    enableResell: nullBoolean(hasKey(data, "enableResell") ? data.enableResell : null, defaults.order.enableResell),
    enableTicketKeeper: nullBoolean(hasKey(data, "enableTicketKeeper") ? data.enableTicketKeeper : null, defaults.order.enableTicketKeeper),
    enableTicketSwap: nullBoolean(hasKey(data, "enableTicketSwap") ? data.enableTicketSwap : null, defaults.order.enableTicketSwap),
    enableTixel: nullBoolean(hasKey(data, "enableTixel") ? data.enableTixel : null, defaults.order.enableTixel),
    footer: {
      showCopyright: nullBoolean(hasKeys(data, "footer", "showCopyright") ? data.footer.showCopyright : null, defaults.order.footer.showCopyright),
      showLocaleSwitcher: nullBoolean(hasKeys(data, "footer", "showLocaleSwitcher") ? data.footer.showLocaleSwitcher : null, defaults.order.footer.showLocaleSwitcher),
      showPoweredBy: nullBoolean(hasKeys(data, "footer", "showPoweredBy") ? data.footer.showPoweredBy : null, defaults.order.footer.showPoweredBy),
      showSupport: nullBoolean(hasKeys(data, "footer", "showSupport") ? data.footer.showSupport : null, defaults.order.footer.showSupport)
    },
    header: {
      showLogo: nullBoolean(hasKeys(data, "header", "showLogo") ? data.header.showLogo : null, defaults.order.header.showLogo)
    }
  };
}
function transformStaticOrderComponentsEventCard(data) {
  const { eventCard } = defaults.order.components;
  return {
    closeUrl: hasKey(data, "closeUrl") && nullString(data.closeUrl) || eventCard.closeUrl,
    disableDownloadButton: nullBoolean(hasKey(data, "disableDownloadButton") ? data.disableDownloadButton : null, eventCard.disableDownloadButton),
    showEventDate: nullBoolean(hasKey(data, "showEventDate") ? data.showEventDate : null, eventCard.showEventDate),
    showLocation: nullBoolean(hasKey(data, "showLocation") ? data.showLocation : null, eventCard.showLocation)
  };
}
function transformStaticShop(data) {
  return {
    blockFrameAccess: nullBoolean(hasKey(data, "blockFrameAccess") ? data.blockFrameAccess : null, defaults.shop.blockFrameAccess),
    enableCoupons: nullBoolean(hasKey(data, "enableCoupons") ? data.enableCoupons : null, defaults.shop.enableCoupons),
    enableTimeslotsFilters: nullBoolean(hasKey(data, "enableTimeslotsFilters") ? data.enableTimeslotsFilters : null, defaults.shop.enableTimeslotsFilters),
    footer: {
      showLocaleSwitcher: nullBoolean(hasKeys(data, "footer", "showLocaleSwitcher") ? data.footer.showLocaleSwitcher : null, defaults.shop.footer.showLocaleSwitcher),
      showPoweredBy: nullBoolean(hasKeys(data, "footer", "showPoweredBy") ? data.footer.showPoweredBy : null, defaults.shop.footer.showPoweredBy)
    },
    rememberTerms: nullBoolean(hasKey(data, "rememberTerms") ? data.rememberTerms : null, defaults.shop.rememberTerms),
    seats: {
      hideLegend: nullBoolean(hasKeys(data, "seats", "hideLegend") ? data.seats.hideLegend : null, defaults.shop.seats.hideLegend),
      hideSectionsNotForSale: nullBoolean(hasKeys(data, "seats", "hideSectionsNotForSale") ? data.seats.hideSectionsNotForSale : null, defaults.shop.seats.hideSectionsNotForSale),
      tooltip: transformStaticShopSeatsTooltip(hasKeys(data, "seats", "tooltip") ? data.seats.tooltip : null)
    },
    showDateBlock: nullBoolean(hasKey(data, "showDateBlock") ? data.showDateBlock : null, defaults.shop.showDateBlock),
    showReservationTimer: nullBoolean(hasKey(data, "showReservationTimer") ? data.showReservationTimer : null, defaults.shop.showReservationTimer)
  };
}
function transformStaticShopSeatsTooltip(data) {
  const { tooltip } = defaults.shop.seats;
  return {
    hideActionHint: nullBoolean(hasKey(data, "hideActionHint") ? data.hideActionHint : null, tooltip.hideActionHint),
    hideAvailability: nullBoolean(hasKey(data, "hideAvailability") ? data.hideAvailability : null, tooltip.hideAvailability),
    hideCategory: nullBoolean(hasKey(data, "hideCategory") ? data.hideCategory : null, tooltip.hideCategory),
    hideLabel: nullBoolean(hasKey(data, "hideLabel") ? data.hideLabel : null, tooltip.hideLabel),
    hidePricing: nullBoolean(hasKey(data, "hidePricing") ? data.hidePricing : null, tooltip.hidePricing),
    hideUnavailableNotice: nullBoolean(hasKey(data, "hideUnavailableNotice") ? data.hideUnavailableNotice : null, tooltip.hideUnavailableNotice)
  };
}
function transformStaticStyle(data) {
  return {
    button: transformStaticStyleButton(hasKey(data, "button") ? data.button : null),
    card: transformStaticStyleCard(hasKey(data, "card") ? data.card : null),
    color: transformStaticStyleColor(hasKey(data, "color") ? data.color : null),
    heading: transformStaticStyleHeading(hasKey(data, "heading") ? data.heading : null),
    shop: transformStaticStyleShop(hasKey(data, "shop") ? data.shop : null),
    text: transformStaticStyleText(hasKey(data, "text") ? data.text : null),
    transition: transformStaticStyleTransition(hasKey(data, "transition") ? data.transition : null)
  };
}
function transformStaticStyleButton(data) {
  const { border } = defaults.style.button;
  return {
    border: {
      radius: hasKeys(data, "border", "radius") && nullString(data.border.radius) || border.radius
    }
  };
}
function transformStaticStyleCard(data) {
  const { card } = defaults.style;
  return {
    border: {
      radius: hasKeys(data, "border", "radius") && nullString(data.border.radius) || card.border.radius
    },
    shadow: hasKey(data, "shadow") && nullString(data.shadow) || card.shadow,
    background: hasKey(data, "background") && nullString(data.background) || card.background,
    color: hasKey(data, "color") && nullString(data.color) || card.color
  };
}
function transformStaticStyleColor(data) {
  const { core } = defaults.style.color;
  function twoColors(colorData, fallback) {
    return {
      primary: hasKey(colorData, "primary") && nullString(colorData.primary) || fallback.primary,
      secondary: hasKey(colorData, "secondary") && nullString(colorData.secondary) || fallback.secondary
    };
  }
  function threeColors(colorData, fallback) {
    return {
      ...twoColors(colorData, fallback),
      tertiary: hasKey(colorData, "tertiary") && nullString(colorData.tertiary) || fallback.tertiary
    };
  }
  return {
    core: {
      accent: threeColors(hasKeys(data, "core", "accent") ? data.core.accent : {}, core.accent),
      background: twoColors(hasKeys(data, "core", "background") ? data.core.background : {}, core.background),
      brand: hasKeys(data, "core", "brand") && nullString(data.core.brand) || core.brand,
      "brand-invert": hasKeys(data, "core", "brand-invert") && nullString(data.core["brand-invert"]) || core["brand-invert"],
      "brand-faded": hasKeys(data, "core", "brand-faded") && nullString(data.core["brand-faded"]) || core["brand-faded"],
      foreground: twoColors(hasKeys(data, "core", "foreground") ? data.core.foreground : {}, core.foreground)
    }
  };
}
function transformStaticStyleHeading(data) {
  const { heading } = defaults.style;
  return {
    font: {
      family: hasKeys(data, "font", "family") && nullString(data.font.family) || heading.font.family,
      weight: hasKeys(data, "font", "weight") && nullString(data.font.weight) || heading.font.weight
    }
  };
}
function transformStaticStyleShop(data) {
  const { shop } = defaults.style;
  return {
    background: hasKey(data, "background") && nullString(data.background) || shop.background,
    color: hasKey(data, "color") && nullString(data.color) || shop.color,
    header: {
      color: {
        accent: hasKeys(data, "header", "color", "accent") && nullString(data.header.color.accent) || shop.header.color.accent
      }
    }
  };
}
function transformStaticStyleText(data) {
  const { text } = defaults.style;
  return {
    font: {
      family: hasKeys(data, "font", "family") && nullString(data.font.family) || text.font.family,
      weight: hasKeys(data, "font", "weight") && nullString(data.font.weight) || text.font.weight
    }
  };
}
function transformStaticStyleTransition(data) {
  const { duration } = defaults.style.transition.default;
  return {
    default: {
      duration: hasKeys(data, "default", "duration") && nullString(data.default.duration) || duration
    }
  };
}
class CustomShopSettingsClient {
  constructor() {
    // TODO introduce a initialized promise.
    __publicField(this, "initialized", false);
    __publicField(this, "static", transformStatic({}));
    __publicField(this, "dynamic", transformDynamic({}));
    __publicField(this, "companyId", "");
    __publicField(this, "config", null);
    __publicField(this, "serializedStaticDefault", JSON.stringify(transformStatic({})));
    __publicField(this, "serializedDynamicDefault", JSON.stringify(transformDynamic({})));
  }
  get isDefault() {
    return this.isStaticDefault && this.isDynamicDefault;
  }
  get isStaticDefault() {
    return JSON.stringify(this.static) === this.serializedStaticDefault;
  }
  get isDynamicDefault() {
    return JSON.stringify(this.dynamic) === this.serializedDynamicDefault;
  }
  get axiosConfig() {
    if (this.companyId) {
      return { headers: { Company: this.companyId } };
    }
    return {};
  }
  async init(config) {
    if (!config.shopId) {
      throw Error("Missing shop ID.");
    }
    if (!config.baseUrlRead && !config.baseUrlWrite && !config.baseUrl) {
      throw Error("Missing base URL read or write.");
    }
    if (!config.httpRead) {
      throw Error("Missing http client for reading custom shop settings.");
    }
    this.config = config;
    const settings = await this._getSettings(config);
    this.static = settings.static;
    this.dynamic = settings.dynamic;
    this.initialized = true;
  }
  async refresh() {
    if (!this.config) {
      throw Error("Custom Shop Settings client not initialized.");
    }
    this.config.disableCache = true;
    const settings = await this._getSettings(this.config);
    this.static = settings.static;
    this.dynamic = settings.dynamic;
  }
  localUpdateStaticSettings(settings) {
    this.static = transformStatic(settings);
  }
  async updateStaticSettings(settings) {
    if (!this.config) {
      throw Error("Custom Shop Settings client not initialized.");
    }
    if (!this.config.httpWrite) {
      throw Error("No write enabled http client provided in constructor.");
    }
    const transformedSettings = transformStatic(settings);
    const path = this._getUrlWrite(this.config, "static");
    await this.config.httpWrite.put(path, transformedSettings, this.axiosConfig);
    this.static = transformedSettings;
  }
  async resetStaticSettings() {
    if (!this.config) {
      throw Error("Custom Shop Settings client not initialized.");
    }
    if (!this.config.httpWrite) {
      throw Error("No write enabled http client provided in constructor");
    }
    const path = this._getUrlWrite(this.config, "static");
    await this.config.httpWrite.put(path, {}, this.axiosConfig);
    this.static = transformStatic({});
  }
  localUpdateDynamicSettings(settings) {
    this.dynamic = transformDynamic(settings);
  }
  async updateDynamicSettings(settings) {
    if (!this.config) {
      throw Error("Custom Shop Settings client not initialized.");
    }
    if (!this.config.httpWrite) {
      throw Error("No write enabled http client provided in constructor");
    }
    const transformedSettings = transformDynamic(settings);
    const path = this._getUrlWrite(this.config, "dynamic");
    await this.config.httpWrite.put(path, transformedSettings, this.axiosConfig);
    this.dynamic = transformDynamic(transformedSettings);
  }
  async resetDynamicSettings() {
    if (!this.config) {
      throw Error("Custom Shop Settings client not initialized.");
    }
    if (!this.config.httpWrite) {
      throw Error("No write enabled http client provided in constructor");
    }
    const path = this._getUrlWrite(this.config, "dynamic");
    await this.config.httpWrite.put(path, {}, this.axiosConfig);
    this.dynamic = transformDynamic({});
  }
  /**
   * Set the company id to provide to the 'css' API
   * @param companyId
   */
  setCompanyScope(companyId) {
    this.companyId = companyId;
  }
  /**
   * This function temporarily sets the company id for the duration of the call.
   * @param companyId
   * @param call
   */
  async withCompanyScope(companyId, call) {
    const oldcompanyId = this.companyId;
    this.companyId = companyId;
    await call();
    this.companyId = oldcompanyId;
  }
  async _getSettings(config) {
    const [staticSettings, dynamicSettings] = await Promise.all([
      this._getStaticSettings(config),
      this._getDynamicSettings(config)
    ]);
    return {
      static: staticSettings,
      dynamic: dynamicSettings
    };
  }
  async _getStaticSettings(config) {
    let path = this._getUrlRead(config, "static");
    if (config.disableCache) {
      path += `?nonce=${Date.now()}`;
    }
    try {
      const response = await config.httpRead.get(path);
      return transformStatic(response.data);
    } catch (e) {
      return transformStatic({});
    }
  }
  async _getDynamicSettings(config) {
    let path = this._getUrlRead(config, "dynamic");
    if (config.disableCache) {
      path += `?nonce=${Date.now()}`;
    }
    try {
      const response = await config.httpRead.get(path);
      return transformDynamic(response.data);
    } catch (e) {
      return transformDynamic({});
    }
  }
  /**
   * Returns the url of where to read the settings
   * If baseUrlRead is set it will look like this: https://yourdomain.com/static-or-dynamic/shop-id.json
   * @param config - Configuration object for custom shop settings
   * @param settingType - Type of setting to write ('static' or 'dynamic')
   * @returns The URL string where to read settings
   */
  _getUrlRead(config, settingType) {
    if (config.baseUrlRead) {
      if (config.baseUrlRead.includes("amazonaws.com")) {
        return urlJoin(config.baseUrlRead, settingType, `${config.shopId}.json`);
      }
      return urlJoin(config.baseUrlRead, config.shopId, settingType);
    }
    if (!config.baseUrl && !config.baseUrlWrite) {
      throw new Error("Custom shop settings: Supply baseUrlRead or baseUrlWrite to read.");
    }
    return this._getUrlWrite(config, settingType);
  }
  /**
   * Returns the url of where to write to the settings
   * If baseUrlWrite or baseUrl is set it will look like this: https://yourdomain.com/shop-id/static-or-dynamic
   * @param config - Configuration object for custom shop settings
   * @param settingType - Type of setting to write ('static' or 'dynamic')
   * @returns The URL string where to write settings
   */
  _getUrlWrite(config, settingType) {
    if (config.baseUrlWrite) {
      return urlJoin(config.baseUrlWrite, config.shopId, settingType);
    }
    if (config.baseUrl) {
      return urlJoin(config.baseUrl, config.shopId, settingType);
    }
    throw Error("Custom shop settings: Supply baseUrlWrite to write.");
  }
}
export {
  CustomShopSettingsClient,
  defaults as STATIC_DEFAULTS,
  transformDynamic,
  transformStatic
};
//# sourceMappingURL=ot-custom-shop-settings.js.map
